export enum NavBarLinks {
    ALL_EVENTS = 'All Events',
    CREATE_EVENT = 'Create Event',
    UPLOAD_EVENTS = 'Upload Events',
    UPLOAD_HISTORY = 'Upload History',
    EVENT_DETAILS = 'Event Details',
    EVENT_CLONE = 'Event Clone',
    RETAILER_DASHBOARD = 'Retailer Dashboard'
}
